import React from 'react';
import { PRACTICE_TOPICS_LABEL, PRACTICE_TOPIC_TIER_PAGES } from '../utils/practiceTopics';

const TierIcon = ({ prefix, level }) => (
  <svg className={`${prefix}-nav-icon`} viewBox="0 0 24 24" fill="none">
    <rect x="4" y="14" width="4" height="7" rx="1" fill="currentColor" opacity={level >= 1 ? 1 : 0.35} />
    <rect x="10" y="10" width="4" height="11" rx="1" fill="currentColor" opacity={level >= 2 ? 1 : 0.35} />
    <rect x="16" y="5" width="4" height="16" rx="1" fill="currentColor" opacity={level >= 3 ? 1 : 0.35} />
  </svg>
);

/**
 * The side menu's Practice Topics entry, built as the Mock Tests entry is: a heading
 * with Beginnings, Foundations and Beyond under it, and the three tier icons the
 * collapsed menu shows in its place. `prefix` is the workspace's CSS prefix
 * ("ucat-ws"), so the entry takes that workspace's own menu styles.
 */
const PracticeTopicsNav = ({
  prefix,
  page,
  onGo,
  label = PRACTICE_TOPICS_LABEL,
  pages = PRACTICE_TOPIC_TIER_PAGES,
}) => (
  <>
    <div className={`${prefix}-nav-group`} role="group" aria-label={label}>
      <div className={`${prefix}-nav-item ${prefix}-nav-parent`}>
        <svg className={`${prefix}-nav-icon`} viewBox="0 0 24 24" fill="none">
          <path d="M4 5.5A2.5 2.5 0 016.5 3H19a1 1 0 011 1v14.5a1 1 0 01-1 1H6.5A2.5 2.5 0 014 17V5.5z" stroke="currentColor" strokeWidth="1.6" />
          <line x1="8" y1="8" x2="16" y2="8" stroke="currentColor" strokeWidth="1.6" />
          <line x1="8" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="1.6" />
        </svg>
        <span className={`${prefix}-nav-label`}>{label}</span>
      </div>
      <div className={`${prefix}-nav-sub`}>
        {pages.map(({ page: id, label: tierLabel, level }) => (
          <button
            key={id}
            type="button"
            className={`${prefix}-nav-subitem ${page === id ? 'active' : ''}`}
            onClick={() => onGo(id)}
          >
            <TierIcon prefix={prefix} level={level} />
            <span className={`${prefix}-nav-label`}>{tierLabel}</span>
          </button>
        ))}
      </div>
    </div>

    {pages.map(({ page: id, label: tierLabel, level }) => (
      <button
        key={`c-${id}`}
        type="button"
        className={`${prefix}-nav-item ${prefix}-collapsed-tier ${page === id ? 'active' : ''}`}
        title={`${label}: ${tierLabel}`}
        aria-label={`${label}: ${tierLabel}`}
        onClick={() => onGo(id)}
      >
        <TierIcon prefix={prefix} level={level} />
        <span className={`${prefix}-nav-label`}>{tierLabel}</span>
      </button>
    ))}
  </>
);

export default PracticeTopicsNav;
